import { render, staticRenderFns } from "./ineligibleDialog.vue?vue&type=template&id=7b71a234&"
import script from "./ineligibleDialog.vue?vue&type=script&lang=js&"
export * from "./ineligibleDialog.vue?vue&type=script&lang=js&"
import style0 from "./ineligibleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ineligibleDialog.vue"
export default component.exports